import { Controller } from "@hotwired/stimulus"

// Simple show/hide tabs. Tabs carry data-tab="<id>", panels data-panel="<id>".
export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = { default: String }

  connect() {
    const first = this.tabTargets[0]?.dataset.tab
    this.activateTab(this.defaultValue || first)
  }

  activate(event) {
    this.activateTab(event.currentTarget.dataset.tab)
  }

  activateTab(id) {
    this.tabTargets.forEach((tab) => {
      const active = tab.dataset.tab === id
      // tab.classList.toggle("border-primary-500", active)
      // tab.classList.toggle("dark:border-primary-300", active)
      // tab.classList.toggle("text-primary-600", active)
      // tab.classList.toggle("dark:text-primary-400", active)
      // tab.classList.toggle("border-transparent", !active)
      // tab.classList.toggle("text-gray-500", !active)
      tab.classList.toggle("tab-selected", active)
    })
    this.panelTargets.forEach((panel) => {
      panel.classList.toggle("hidden", panel.dataset.panel !== id)
    })
  }
}
